import React from "react";

function VideoPauseMobile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="55"
      height="55"
      viewBox="0 0 55 55"
    >
      <g id="Pause_Icon" data-name="Pause Icon" transform="translate(0.001 0)">
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="27.5"
          cy="27.5"
          r="27.5"
          transform="translate(-0.001 0)"
          opacity="0.5"
        />
        <g
          id="Icon_ion-ios-pause"
          data-name="Icon ion-ios-pause"
          transform="translate(20.222 18.012)"
        >
          <path
            id="Path_19896"
            data-name="Path 19896"
            d="M13.311,25.938H9.486A.482.482,0,0,1,9,25.458V7.23a.482.482,0,0,1,.486-.48h3.826a.482.482,0,0,1,.486.48V25.458A.482.482,0,0,1,13.311,25.938Z"
            transform="translate(-9 -6.75)"
            fill="#fff"
          />
          <path
            id="Path_19897"
            data-name="Path 19897"
            d="M25.686,25.938H21.861a.482.482,0,0,1-.486-.48V7.23a.482.482,0,0,1,.486-.48h3.826a.482.482,0,0,1,.486.48V25.458A.482.482,0,0,1,25.686,25.938Z"
            transform="translate(-10.822 -6.75)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default VideoPauseMobile;
